import { Pipe, PipeTransform } from '@angular/core';
import {
  isInteger,
  isNumberFinite,
  isPositive,
  toDecimal,
} from '@core/utils/numbers';

export type ByteUnit = 'B' | 'kB' | 'KB' | 'MB' | 'GB' | 'TB';

@Pipe({
  name: 'filesize',
})
export class FilesizePipe implements PipeTransform {
  static formats: { [key: string]: { max: number; prev?: ByteUnit } } = {
    B: { max: 1024 },
    kB: { max: Math.pow(1024, 2), prev: 'B' },
    KB: { max: Math.pow(1024, 2), prev: 'B' }, // Backward compatible
    MB: { max: Math.pow(1024, 3), prev: 'kB' },
    GB: { max: Math.pow(1024, 4), prev: 'MB' },
    TB: { max: Number.MAX_SAFE_INTEGER, prev: 'GB' },
  };

  static formatResult(result: number, unit: string): string {
    return `${result} ${unit}`;
  }

  static calculateResult(
    format: { max: number; prev?: ByteUnit },
    bytes: number
  ) {
    const prev = format.prev ? FilesizePipe.formats[format.prev] : undefined;
    return prev ? bytes / prev.max : bytes;
  }
  transform(
    input: any,
    decimal: number = 0,
    from: ByteUnit = 'B',
    to?: ByteUnit
  ): any {
    if (
      !(
        isNumberFinite(input) &&
        isNumberFinite(decimal) &&
        isInteger(decimal) &&
        isPositive(decimal)
      )
    ) {
      return input;
    }

    let bytes = input;
    let unit = from;
    while (unit !== 'B') {
      bytes *= 1024;
      unit = FilesizePipe.formats[unit].prev;
    }

    if (to) {
      const format = FilesizePipe.formats[to];

      const result = toDecimal(
        FilesizePipe.calculateResult(format, bytes),
        decimal
      );

      return FilesizePipe.formatResult(result, to);
    }

    for (const key in FilesizePipe.formats) {
      if (FilesizePipe.formats.hasOwnProperty(key)) {
        const format = FilesizePipe.formats[key];
        if (bytes < format.max) {
          const result = toDecimal(
            FilesizePipe.calculateResult(format, bytes),
            decimal
          );

          return FilesizePipe.formatResult(result, key);
        }
      }
    }
  }
}
